import { combineReducers } from 'redux';
import merge from 'lodash/merge';

const byId = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.team
  ) {
    return merge({}, state, action.response.entities.team);
  }
  return state;
};

const reducer = combineReducers({
  byId,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/team/team.reducer.js